/* eslint-disable no-unused-vars */
import {
  Card,
  CardContent,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDatePicker from "../../../components/pos/PDatePicker";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { Store } from "../../../utils/Store";
import { SyncUtils } from "../../../utils/SyncUtils";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import PCheck from "../../../components/pos/PCheck";
import PRSelect from "../../../components/pos/PRSelect";
import ChequePrint from "../ChequePrint/ChequePrint";
import { HelpOutline } from "@mui/icons-material";
import { SaleUtils } from "../../../utils/SaleUtils";
import { StringUtils } from "../../../utils/StringUtils";

export default function TransactionsCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState(
    translate("New Transactions")
  );

  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [voucherNumber, setVoucherNumber] = useState("AUTO");
  const [voucherNumberError, setVoucherNumberError] = useState("");
  const [fromLedger, setFromledger] = useState("");
  const [fromLedgerError, setFromledgerError] = useState("");

  const [toLedger, setToledger] = useState("");
  const [toLedgerError, setToledgerError] = useState("");

  const [discount, setDiscount] = useState("");
  const [discountError, setDiscountError] = useState("");

  const [actualAmount, setActualAmount] = useState("");

  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [payerName, setPayerName] = useState("");
  const [payerNameError, setPayerNameError] = useState("");
  const [payeeName, setPayeeName] = useState("");
  const [payeeNameError, setPayeeNameError] = useState("");
  const [status, setStatus] = useState("");
  const [statusError, setStatusError] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [referenceNumber, setReferencenumber] = useState("");
  const [referenceNumberError, setReferencenumberError] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [transactionDate, setTransactiondate] = useState("");
  const [transactionDateError, setTransactiondateError] = useState("");
  const [transactionMode, setTransactionMode] = useState("");
  const [type, setType] = useState("");
  const [optionsLedger, setOptionsLedger] = useState([]);
  const [fromLedgerOptions, setFromLedgerOptions] = useState([]);
  const [toLedgerOptions, setToLedgerOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [fromLedgerBalance, setFromLedgerBalance] = useState(0);
  const [toLedgerBalance, setToLedgerBalance] = useState(0);
  const [fromLedgerNature, setFromLedgerNature] = useState("");
  const [toLedgerNature, setToLedgerNature] = useState("");
  const [taxable, setTaxable] = useState(false);
  const [showTaxableOption, setShowTaxableOption] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [getPrint, setGetPrint] = useState(false);
  const [finacialYear, setFinacialYear] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [fromBalance, setFromBalance] = useState("");
  const [toBalance, setToBalance] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [chequeNo, setchequeNo] = useState("");
  const [chequeNoError, setChequeNoError] = useState("");
  const [narration, setNarration] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [chequeDateError, setChequeDateError] = useState("");

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showTransactionsCrudWindow: showTransactionsCrudWindow,
  };

  useEffect(() => {
    setStatusOptions([
      { name: "Completed", value: translate("Completed") },
      { name: "Pending", value: translate("Pending") },
    ]);
    loadFinancilYear();
  }, []);

  useEffect(() => {
    if (props.viewOnlyForUpdate === "only_view") {
      setMode("view");
    }
  }, [props.viewOnlyForUpdate]);

  useEffect(() => {
    if (liveValidation && chequeDate === "") {
      setChequeDateError(translate("Cheque Date is Required"));
    } else {
      setChequeDateError("");
    }
  }, [chequeDate]);

  useEffect(() => {
    if (liveValidation && chequeNo === "") {
      setChequeNoError(translate("Cheque No is Required"));
    } else {
      setChequeNoError("");
    }
  }, [chequeNo]);

  useEffect(() => {
    if (fromLedgerOptions.length == 1) {
      setFromledger(fromLedgerOptions[0]);
    }
  }, [fromLedgerOptions]);

  useEffect(() => {
    if (props.type == "Payment") {
      if (fromLedger == null) {
        setStatusFlag(false);
      } else if (fromLedger.typeName === "Bank Accounts") {
        setStatusFlag(true);
        setTransactionMode("Bank");
      } else {
        setStatusFlag(false);
        setTransactionMode("Cash");
      }
    }
  }, [fromLedger]);

  useEffect(() => {
    if (props.type == "Receipt") {
      if (toLedger == null) {
        setStatusFlag(false);
      } else if (toLedger.typeName === "Bank Accounts") {
        setStatusFlag(true);
        setTransactionMode("Bank");
      } else {
        setStatusFlag(false);
        setTransactionMode("Cash");
      }
    }
  }, [toLedger]);

  useEffect(() => {
    setActualAmount(
      StringUtils.formattedNumber(
        parseFloat(amount) - parseFloat(discount == "" ? 0 : discount),
        props.context.store.currencyDecimal
      )
    );
  }, [discount]);

  useEffect(() => {
    setActualAmount(
      StringUtils.formattedNumber(
        parseFloat(amount) - parseFloat(discount == "" ? 0 : discount),
        props.context.store.currencyDecimal
      )
    );
  }, [amount]);

  async function loadFinancilYear() {
    let { data } = await API.get("/api/v1/currentfinancialyear");
    setFinacialYear(data);
  }

  // useEffect(() => {
  //   if (liveValidation && fromLedgerOptions.length < 0) {
  //     props.showMessage("error", translate("Unable to find To account ledger"));
  //   }
  //   console.log("toLedgerOptions", toLedgerOptions);
  // }, [toLedgerOptions]);

  useEffect(() => {
    if (liveValidation && actualAmount < 0)
      setDiscountError(translate("Invalid Discount"));
    else setDiscountError("");
  }, [actualAmount]);

  useEffect(() => {
    if (liveValidation && voucherNumber === "")
      setVoucherNumberError(translate("Voucher Number is Required"));
    else setVoucherNumberError("");
  }, [voucherNumber]);

  useEffect(() => {
    if (liveValidation && fromLedger == null) {
      setFromledgerError(translate("From Ledger is Required"));
    } else setFromledgerError("");
    if (fromLedger) {
      populateBalance(fromLedger, "fromLedger");
    }
  }, [fromLedger]);

  useEffect(() => {
    if (liveValidation && (toLedger === "" || toLedger == null))
      setToledgerError(translate("To Ledger is Required"));
    else setToledgerError("");
    if (toLedger) {
      populateBalance(toLedger, "toLedger");
    }
  }, [toLedger]);

  useEffect(() => {
    if (liveValidation && amount === "")
      setAmountError(translate("Amount is Required"));
    else setAmountError("");
  }, [amount]);

  useEffect(() => {
    if (liveValidation && payerName === "")
      setPayerNameError(translate("Payer name is Required"));
    else setPayerNameError("");
  }, [payerName]);

  useEffect(() => {
    if (liveValidation && payeeName === "")
      setPayeeNameError(translate("Payee name is Required"));
    else setPayeeNameError("");
  }, [payeeName]);

  // useEffect(() => {
  //   if (liveValidation && status === "")
  //     setStatusError(translate("Status is Required"));
  //   else setStatusError("");
  // }, [status]);

  useEffect(() => {
    if (liveValidation && transactionDate === "")
      setTransactiondateError(translate("Transaction date is Required"));
    else setTransactiondateError("");
  }, [transactionDate]);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  async function getAllLedgers(mode) {
    setOptionsLedger([]);
    let ledgers = await API.get("/api/v1/ledgerlist");
    getCashBankAccounts(mode, ledgers.data);
    getGeneralLedgers(ledgers.data);
  }

  function getGeneralLedgers(ledgers) {
    let generalLedgers = ledgers.filter(
      (element) =>
        element.type != "VENDOR" &&
        element.type != "CUSTOMER" &&
        !element.code.startsWith("010103") &&
        !element.code.startsWith("010102")
    );
    if (props.type === "Receipt")
      setFromLedgerOptions(populateFromLedgerOptions(generalLedgers));
    else if (props.type === "Payment")
      setToLedgerOptions(populateToLedgerOptions(generalLedgers));
  }

  async function populateBalance(ledger, type) {
    let { data } = await API.post("report/generate", {
      pluginMode: "v2",
      template: "reports/generic/accounts/ledgerExplorer",
      justSummary: true,
      extraParams:
        '{"ledgerCode":"' +
        ledger.value.code +
        '","financialYear":"' +
        finacialYear.id +
        '"}',
      outFormat: "json",
      reportTypeOptions: "html",
    });

    if ("fromLedger" === type) {
      setFromBalance(data.summary.balance);
    }
    if ("toLedger" === type) {
      setToBalance(data.summary.balance);
    }
  }

  function getCashBankAccounts(mode, ledgers) {
    let cashBankLedgers = [];
    if (mode === "Cash") {
      cashBankLedgers = ledgers.filter((element) =>
        element.code.startsWith("010103")
      );
    } else if (mode === "Bank") {
      cashBankLedgers = ledgers.filter((element) =>
        element.code.startsWith("010102")
      );
    } else {
      cashBankLedgers = ledgers.filter(
        (element) =>
          element.code.startsWith("010102") || element.code.startsWith("010103")
      );
    }

    if (props.type === "Payment")
      setFromLedgerOptions(populateFromLedgerOptions(cashBankLedgers));
    else if (props.type === "Receipt")
      setToLedgerOptions(populateToLedgerOptions(cashBankLedgers));
    else if (props.type === "CONTRA") {
      setFromLedgerOptions(populateFromLedgerOptions(cashBankLedgers));
      setToLedgerOptions(populateFromLedgerOptions(cashBankLedgers));
    }
  }

  function populateFromLedgerOptions(data) {
    const dataArray = [];
    data.map((item, key) =>
      dataArray.push({
        id: item.id,
        name: item.name,
        value: item,
        typeName: item.parentLedger.name,
      })
    );
    return dataArray;
  }

  function populateToLedgerOptions(data) {
    try {
      const dataArray = [];
      data.map((item, key) => {
        dataArray.push({
          id: item.id,
          name: item.name,
          value: item,
          label: item.name,
          typeName: item.parentLedger.name,
        });
      });
      return dataArray;
    } catch (err) {
      props.showMessage("error", translate("Unable to find To Ledger Options"));
    }
  }

  function showTransactionsCrudWindow(transMode, transactionsId) {
    setOpenWindow(true);
    getAllLedgers(transMode);
    if (props.type === "Payment") {
      setShowTaxableOption(true);
    }

    if (transMode == null) {
      setWindowTitile("New " + props.type);
    } else {
      setWindowTitile("New " + transMode + " " + props.type);
    }

    if (transactionsId == null) {
      setVoucherNumber("AUTO");
      setTransactionMode(transMode);
      setType(props.type);
      // setWindowTitile("New " + transMode + " " + props.type);
      resetFields();
      setMode("create");
      setLiveValidation(false);
      let d = new Date();
      d.setHours(d.getHours());
      d.setMinutes(d.getMinutes());
      d.setSeconds(d.getSeconds());
      setTransactiondate(d.toISOString());
    } else {
      setMode(
        props.userPrivilegeForUpdate || props.userPrivilegeForDelete
          ? "edit"
          : "view"
      );
      setReadOnly(false);
      populateTransactions(transactionsId);
    }
  }
  async function populateTransactions(id) {
    {
      try {
        let { data } = await API.get("/api/v1/accounting/transaction/" + id);
        setOrigObject(data);
        populateData(data);
        setWindowTitile(data.voucherNumber);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Transactions data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setVoucherNumber(bean.voucherNumber);
    setFromledger(
      bean.fromLedger
        ? {
            id: bean.fromLedger.id,
            name: bean.fromLedger.name,
            value: bean.fromLedger,
          }
        : null
    );

    setToledger(
      bean.toLedger
        ? {
            id: bean.toLedger.id,
            name: bean.toLedger.name,
            value: bean.toLedger,
          }
        : null
    );

    setFromLedgerBalance(bean.fromLedger.balance);
    setToLedgerBalance(bean.toLedger.balance);
    setAmount(bean.amount);
    setDiscount(bean.discount);
    setActualAmount(bean.actualAmount);
    setPayeeName(bean.payeeName);
    setPayerName(bean.payerName);
    setStatus(
      bean.status ? SaleUtils.getOption2(statusOptions, bean.status) : null
    );
    setType(bean.type);
    setTransactionMode(bean.transactionMode);
    setReferencenumber(bean.referenceNumber);
    setDescription(bean.description);
    setTaxable(bean.taxable);
    setTransactiondate(bean.transactionDate2);
    setchequeNo(bean.chequeNo);
    setChequeDate(bean.chequeDate);
    setNarration(bean.narration);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setChequeDate("");
    setChequeDateError("");
    setChequeNoError("");
    setActualAmount("");
    setDiscount("");
    setDiscountError("");
    setFromledger(null);
    setFromledgerError("");
    setToledger(null);
    setToledgerError("");
    setAmount("");
    setAmountError("");
    setPayerNameError("");
    setTaxable(false);
    setPayeeNameError("");
    setStatus("");
    setStatusError("");
    setReferencenumber("");
    setReferencenumberError("");
    setDescription("");
    setDescriptionError("");
    setTransactiondate("");
    setTransactiondateError("");
    setFromLedgerBalance(0);
    setToLedgerBalance(0);
    setFromLedgerNature("");
    setToLedgerNature("");
    setchequeNo("");
    setNarration("");
    let token = localStorage.getItem("w_accessToken");
    let jwt = Store.parseJwt(token);
    if (props.type == "Payment") {
      setPayerName(jwt.sub);
      setPayeeName("");
    } else if (props.type == "Receipt") {
      setPayerName("");
      setPayeeName(jwt.sub);
    } else {
      setPayerName("");
      setPayeeName("");
    }
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
    resetFields();
    props.setViewOnlyForUpdate("");
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete transactions") +
        ":" +
        origObject.voucherNumber +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }
  var biRef = {};

  function onChequePrint() {
    biRef.chequeRef.showChequePrintWindow(origObject);
  }

  //Delete transaction: Backed validation pending
  //********* */

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete(
          "/api/v1/accountingtransaction/" + origObject.id
        );
        props.showMessage(
          "warning",
          translate("Transactions ") + voucherNumber + translate(" got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage(
          "error",
          translate("Not able to Delete Transactions")
        );
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave(print) {
    setGetPrint(print);

    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/accountingtransaction", payload);
        // setMode("edit");
        setMode(
          props.userPrivilegeForUpdate || props.userPrivilegeForDelete
            ? "edit"
            : "view"
        );
        props.showMessage("success", translate("Saved Successfully"));
        populateTransactions(result.data.id);
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        if (getPrint) {
          let paramsList = [
            {
              key: "transactionId",
              value: result.data.id,
            },
          ];

          if (props.type === "Payment") {
            biRef.genericReportView.showGenericReportViewer(
              "reports/generic/account_transactions/payment",
              paramsList,
              translate("Accounts Transaction")
            );
          }

          if (props.type == "Receipt") {
            biRef.genericReportView.showGenericReportViewer(
              "reports/generic/account_transactions/receipt",
              paramsList,
              translate("Accounts Transaction")
            );
          }
          if (props.type === "CONTRA") {
            biRef.genericReportView.showGenericReportViewer(
              "reports/generic/account_transactions/contra",
              paramsList,
              translate("Accounts Transaction")
            );
          }
        }
        showProgress(false, "Saving");
      } catch (err) {
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage(
            "error",
            translate("Not able to Save Transactions")
          );
        }
        showProgress(false, "Saving");
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "voucherNumber") {
        setVoucherNumberError(obj.message);
      }
      if (obj.field === "fromLedger") {
        setFromledgerError(obj.message);
      }
      if (obj.field === "toLedger") {
        setToledgerError(obj.message);
      }
      if (obj.field === "amount") {
        setAmountError(obj.message);
      }
      if (obj.field === "payerName") {
        setPayerNameError(obj.message);
      }
      if (obj.field === "payeeName") {
        setPayeeNameError(obj.message);
      }
      if (obj.field === "status") {
        setStatusError(obj.message);
      }
      if (obj.field === "referenceNumber") {
        setReferencenumberError(obj.message);
      }
      if (obj.field === "description") {
        setDescriptionError(obj.message);
      }
      if (obj.field === "transactionDate") {
        setTransactiondateError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }
  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["voucherNumber"] = voucherNumber;
    saveObject["fromLedger"] = fromLedger.value;
    saveObject["toLedger"] = toLedger.value;
    saveObject["fromLedgerName"] = fromLedger.name;
    saveObject["toLedgerName"] = toLedger.name;
    saveObject["payerName"] = payerName;
    saveObject["payeeName"] = payeeName;
    saveObject["status"] = status ? status.value : "";
    saveObject["referenceNumber"] = referenceNumber;
    saveObject["description"] = description;
    saveObject["transactionDate"] = transactionDate;
    saveObject["transactionDate2"] = transactionDate;
    saveObject["type"] = type;
    saveObject["transactionMode"] = transactionMode;
    saveObject["taxable"] = taxable;
    saveObject["amount"] = amount;
    saveObject["actualAmount"] = actualAmount;
    saveObject["discount"] = discount == 0 ? 0 : discount;
    saveObject["chequeNo"] = chequeNo;
    saveObject["narration"] = narration;
    saveObject["chequeDate"] = chequeDate;
    saveObject["chequeStatus"] = transactionMode == "Bank" ? "PENDING" : "";

    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (actualAmount < 0) {
      setDiscountError(translate("Invalid Discount"));
      flag = false;
    }
    if (!voucherNumber || voucherNumber === "") {
      setVoucherNumberError(translate("Voucher Number is Required"));
      flag = false;
    }
    if (!fromLedger || fromLedger === "") {
      setFromledgerError(translate("From Ledger is Required"));
      flag = false;
    }
    if (!toLedger || toLedger === "") {
      setToledgerError(translate("To Ledger is Required"));
      flag = false;
    }
    if (!amount || amount === "") {
      setAmountError(translate("Amount is Required"));
      flag = false;
    }
    if (!payerName || payerName === "") {
      setPayerNameError(translate("Payer name is Required"));
      flag = false;
    }
    if (!payeeName || payeeName === "") {
      setPayeeNameError(translate("Payee name is Required"));
      flag = false;
    }
    // if (transactionMode === "Bank" || statusFlag == true) {
    //   if (!status || status === "") {
    //     setStatusError(translate("Status is Required"));
    //     flag = false;
    //   }
    // }
    if (!transactionDate || transactionDate === "") {
      setTransactiondateError(translate("Transaction date is Required"));
      flag = false;
    }
    if (
      (!chequeDate || chequeDate === "") &&
      (transactionMode === "Bank" || statusFlag == true)
    ) {
      setChequeDateError(translate("Cheque Date is Required"));
      flag = false;
    }
    if (
      (!chequeNo || chequeNo === "") &&
      (transactionMode === "Bank" || statusFlag == true)
    ) {
      setChequeNoError(translate("Cheque No is Required"));
      flag = false;
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  function handleAmountChange(e) {
    try {
      let frombal = fromLedger.value.balance;
      let tobal = toLedger.value.balance;
      setAmount(e.target.value);
      if (
        fromLedgerNature === "DEBIT" ||
        fromLedgerNature === "" ||
        fromLedgerNature === null
      ) {
        if (mode === "create") {
          frombal = Number(frombal) - Number(e.target.value);
        } else if (mode === "edit") {
          frombal =
            Number(frombal) +
            Number(origObject.amount) -
            Number(e.target.value);
        }

        if (Number(frombal) < 0) {
          setFromLedgerNature("CREDIT");
          frombal = Number(frombal) * -1;
          setFromLedgerBalance(frombal);
        } else if (Number(frombal) == 0) setFromLedgerNature("");
      } else if (fromLedgerNature == "CREDIT")
        setFromLedgerBalance(
          mode === "edit"
            ? Number(frombal) -
                Number(origObject.amount) +
                Number(e.target.value)
            : Number(frombal) + Number(e.target.value)
        );

      if (
        toLedgerNature === "CREDIT" ||
        toLedgerNature === "" ||
        toLedgerNature == null
      ) {
        if (mode === "create") {
          tobal = Number(tobal) - Number(e.target.value);
        } else if (mode === "edit") {
          frombal =
            Number(tobal) + Number(origObject.amount) - Number(e.target.value);
        }
        if (Number(tobal) < 0) {
          setToLedgerNature("DEBIT");
          tobal = Number(tobal) * -1;
          setToLedgerBalance(tobal);
        } else if (Number(tobal) == 0) setToLedgerNature("");
      } else if (toLedgerNature == "DEBIT")
        setToLedgerBalance(
          mode === "edit"
            ? Number(tobal) - Number(origObject.amount) + Number(e.target.value)
            : Number(tobal) + Number(e.target.value)
        );
    } catch (err) {
      props.showMessage("error", translate("Please Select Ledger"));
    }
  }

  function findParent(code) {
    let parentCode = code.substring(0, 2);
    let parent = "";
    switch (parentCode) {
      case "01":
        parent = "Assets";
        break;
      case "02":
        parent = "Liability";
        break;
      case "03":
        parent = "Expense";
        break;
      case "04":
        parent = "Income";
        break;
      default:
        parent = "";
        break;
    }
    return parent;
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={8}>
            {option.value.name}
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right", fontSize: 12 }}>
            {findParent(option.value.code)}
          </Grid>
        </Grid>
      );
    }
    if (!option.value) return "";
    return option.value.name;
  };

  function onNewClicked() {
    showTransactionsCrudWindow(null, null);
  }

  const customFilterOptionfromLedger = (fromLedgerOptions, rawInput) => {
    if(rawInput){
      const inputValue = rawInput.toUpperCase();
      const label = fromLedgerOptions.data.name.toUpperCase();
      return label.startsWith(inputValue);
    }else{
      return true
    }
      };

      const customFilterOptiontoLedgerOptions = (toLedgerOptions, rawInput) => {
        if(rawInput){
          const inputValue = rawInput.toUpperCase();
          const label = toLedgerOptions.label.toUpperCase();
          return label.startsWith(inputValue);
        }else{
          return true
        }
          };

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Voucher Number")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={voucherNumber}
                    error={voucherNumberError}
                    onChange={(e) => setVoucherNumber(e.target.value)}
                    InputProps={{ readOnly: true }}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("From Account")}
                  </Typography>
                </td>
                <td>
                  <PRSelect
                    options={fromLedgerOptions}
                    filterOption={customFilterOptionfromLedger}
                    value={fromLedger}
                    errorMessage={fromLedgerError}
                    formatOptionLabel={formatOptionLabel}
                    components={{ formatOptionLabel }}
                    onChange={(newValue) => {
                      setFromledger(newValue);
                      setFromLedgerBalance(newValue.value.balance);
                      setFromLedgerNature(newValue.value.nature);
                    }}
                  ></PRSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("To Account")}
                  </Typography>
                </td>
                <td>
                  <PRSelect
                    options={toLedgerOptions}
                    filterOption={customFilterOptiontoLedgerOptions}
                    formatOptionLabel={formatOptionLabel}
                    components={{ formatOptionLabel }}
                    errorMessage={toLedgerError}
                    onChange={(newValue) => {
                      setToledger(newValue);
                      setToLedgerBalance(newValue.value.balance);
                      setToLedgerNature(newValue.value.nature);
                    }}
                    value={toLedger}
                  ></PRSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Amount")}</Typography>
                </td>
                <td>
                  <PText
                    style={
                      showTaxableOption
                        ? { width: "36%", marginRight: 10 }
                        : { width: "100%" }
                    }
                    type="number"
                    value={amount}
                    error={amountError}
                    InputProps={{ readOnly: readOnly }}
                    onChange={(e) => {
                      handleAmountChange(e);
                    }}
                  ></PText>
                  {showTaxableOption && (
                    <PCheck
                      onChange={(value) => {
                        setTaxable(value);
                      }}
                      checked={taxable}
                      label={translate("Taxable")}
                      disabled={readOnly}
                    ></PCheck>
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Discount")}
                  </Typography>
                </td>

                <td>
                  <table width={"100%"}>
                    <tbody>
                      <tr>
                        <td>
                          <PText
                            style={{
                              width: 154,
                              marginLeft: -3,
                            }}
                            type="number"
                            value={discount}
                            error={discountError}
                            onChange={(e) => setDiscount(e.target.value)}
                          ></PText>
                        </td>
                        <td style={{ paddingLeft: 7 }}>Actual Amount</td>
                        <td>
                          <PText
                            style={{
                              width: 138,
                              marginLeft: 11,
                            }}
                            type="number"
                            value={actualAmount}
                            InputProps={{ readOnly: readOnly }}
                          ></PText>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Transaction Date")}
                  </Typography>
                </td>
                <td>
                  <PDatePicker
                    value={transactionDate}
                    type="date"
                    disabled={readOnly}
                    error={transactionDateError}
                    onChange={(e) => {
                      let d = new Date();
                      e.$d.setHours(d.getHours());
                      e.$d.setMinutes(d.getMinutes());
                      e.$d.setSeconds(d.getSeconds());
                      setTransactiondate(e.$d.toISOString());
                    }}
                  ></PDatePicker>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Payer")}</Typography>
                </td>
                <td>
                  <PText
                    value={payerName}
                    error={payerNameError}
                    onChange={(e) => setPayerName(e.target.value)}
                    InputProps={{ readOnly: readOnly }}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Payee")}</Typography>
                </td>
                <td>
                  <PText
                    value={payeeName}
                    error={payeeNameError}
                    onChange={(e) => setPayeeName(e.target.value)}
                    InputProps={{ readOnly: readOnly }}
                  ></PText>
                </td>
              </tr>
              {(transactionMode === "Bank" || statusFlag == true) && (
                <tr>
                  <td>
                    <Typography variant="body1">
                      {translate("Cheque No")}
                    </Typography>
                  </td>
                  <td>
                    <PText
                      value={chequeNo}
                      error={chequeNoError}
                      onChange={(e) => setchequeNo(e.target.value)}
                    ></PText>
                  </td>
                </tr>
              )}
              {(transactionMode === "Bank" || statusFlag == true) && (
                <tr>
                  <td>
                    <Typography variant="body1">
                      {translate("Cheque Date")}
                    </Typography>
                  </td>
                  <td>
                    <PDatePicker
                      value={chequeDate}
                      type="date"
                      disabled={readOnly}
                      error={chequeDateError}
                      onChange={(e) => {
                        let d = new Date();
                        e.$d.setHours(d.getHours());
                        e.$d.setMinutes(d.getMinutes());
                        e.$d.setSeconds(d.getSeconds());
                        setChequeDate(e.$d.toISOString());
                      }}
                    ></PDatePicker>
                  </td>
                </tr>
              )}

              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Reference Number")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={referenceNumber}
                    error={referenceNumberError}
                    onChange={(e) => setReferencenumber(e.target.value)}
                    InputProps={{ readOnly: readOnly }}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Description")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={description}
                    error={descriptionError}
                    onChange={(e) => setDescription(e.target.value)}
                    InputProps={{ readOnly: readOnly }}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Narration")}
                  </Typography>
                </td>
                <td>
                  <PText
                    multiline={true}
                    value={narration}
                    onChange={(e) => setNarration(e.target.value)}
                    InputProps={{ readOnly: readOnly }}
                  ></PText>
                </td>
              </tr>

              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={4}>
          <Card style={{ height: 330 }}>
            <CardContent style={{ padding: 5 }}>
              <Typography
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontFamily: "sans-serif",
                  fontSize: 25,
                  color: "Black",
                  paddingBottom: 5,
                }}
                variant="body1"
              >
                {translate("Accounts Summary")}
              </Typography>
              <br></br>
              <Typography
                color="primary"
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                variant="body1"
              >
                {translate("From Account")}:
                {
                  <Typography
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                      color: "black",
                    }}
                    variant="body1"
                  >
                    {fromLedger ? fromLedger.name : ""}
                  </Typography>
                }
              </Typography>

              <Typography
                color="secondary"
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                variant="body1"
              >
                {translate("Balance")}:
                {
                  <Typography
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                      color: "black",
                    }}
                    variant="body1"
                  >
                    {fromBalance}
                  </Typography>
                }
              </Typography>
              <br />
              <Typography
                color="primary"
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                variant="body1"
              >
                {translate("To Account")}:
                {
                  <Typography
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                      color: "black",
                    }}
                    variant="body1"
                  >
                    {toLedger ? toLedger.name : ""}
                  </Typography>
                }
              </Typography>

              <Typography
                color="secondary"
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                variant="body1"
              >
                {translate("Balance")}:
                {
                  <Typography
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                      color: "black",
                    }}
                    variant="body1"
                  >
                    {toBalance}
                  </Typography>
                }
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    /*
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }*/
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          hideSave={
            (!props.userPrivilegeForUpdate && props.userPrivilegeForDelete) ||
            mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
          showPrint={
            (props.userPrivilegeForDelete && !props.userPrivilegeForUpdate) ||
            mode === "view"
              ? mode === "create"
                ? true
                : false
              : true
          }
          showChequePrint={
            props.type == "Payment" &&
            transactionMode === "Bank" &&
            mode != "create"
              ? true
              : false
          }
          onChequePrint={onChequePrint}
          onPrint={() => onSave(true)}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={() => onSave(false)}
          onDelete={props.userPrivilegeForDelete ? onDelete : false}
          mode={mode}
          isDataChanged={isDataChanged}
          showNew={props.readOnly ? false : mode != "create" ? true : false}
          onNewClicked={onNewClicked}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
      ></GenericReportViewer>
      <ChequePrint
        biRef={biRef}
        showMessage={props.showMessage}
        showProgress={props.showProgress}
        hideProgress={props.hideProgress}
        setAlert={props.setAlert}
      ></ChequePrint>

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
